import InfoVM from './info-vm';
export default {
  init: function(){
    console.log('Initializing Kadenze.CommonResourceInfoModal');

    let el = document.getElementById('resource_info_modal');
    if (el) {
      let vm = new InfoVM();
      ko.applyBindings(vm, el);
    }
  }
};
